/*
 * @Description: 
 * @Version: 2.0
 * @Autor: chenkang
 * @Date: 2021-09-01 17:46:54
 * @LastEditors: qiuwenjing qiuwenjing@vip56.cn
 * @LastEditTime: 2025-08-18 15:20:17
 */
import { Post, Get, Patch, Put, Delete, Download, ax } from './http_pad';
import { type } from './interface';
import qs from 'qs';
export namespace TbShop {
    /**
     * 查询店铺
     */
    export var GetTbShopById = (body: any): Promise<any> => {
        return Get(`/api/TbShop/GetTbShopById`, body);
    };
    /**
     * 获取店铺审核信息
     */
    export var GetTbShopApproveInfoByShopNo = (): Promise<any> => {
        return Get(`/api/TbShop/GetTbShopApproveInfoByShopNo`, {});
    };
    /**
     * 切换店铺查询店铺列表
     */
    export var GetTbShoppListForSwitch = (body: any): Promise<any> => {
        return Get(`/api/TbShop/GetTbShoppListForSwitch`, body);
    };
    /**修改店铺 */
    export var PutUpdateTbShop = (body): Promise<any> => {
        return Put(`/api/TbShop/PutUpdateTbShop`, body);
    };
    /**修改店铺 */
    export var PutShopInfo = (body): Promise<any> => {
        return Put(`/api/TbShop/PutShopInfo`, body);
    };
    /**获取个体经营类目列表 */
    export var GetBusinessCategorys = (): Promise<any> => {
        return Get(`/api/TbShop/GetBusinessCategorys`, {});
    };
    /**获取门店信息 */
    export var GetInitShopInfo = (body): Promise<any> => {
        return Get(`/api/TbShop/GetInitShopInfo`, body);
    };
    /**更新标签模板类型 */
    export var PutShopLabelTemplateType = (body): Promise<any> => {
        return Put(`/api/TbShop/PutShopLabelTemplateType`, body);
    };
    /**更新Web小票模板类型 */
    export var PutWebShopReceiptTemplateType = (body): Promise<any> => {
        return Put(`/api/TbShop/PutWebShopReceiptTemplateType`, body);
    };
    /**更新Web标签模板类型 */
    export var PutWebShopLabelTemplateType = (body): Promise<any> => {
        return Put(`/api/TbShop/PutWebShopLabelTemplateType`, body);
    };
    /**获取门店信息 */
    export var GetInitShopInfo = (body): Promise<any> => {
        return Get(`/api/TbShop/GetInitShopInfo`, body);
    };
    /**更新标签模板类型 */
    export var PutShopLabelTemplateType = (body): Promise<any> => {
        return Put(`/api/TbShop/PutShopLabelTemplateType`, body);
    };
    /**更新小票模板类型 */
    export var PutPadShopReceiptTemplateType = (body): Promise<any> => {
        return Put(`/api/TbShop/PutPadShopReceiptTemplateType`, body);
    };
    /**更新Pad标签模板类型 */
    export var PutPadShopLabelTemplateType = (body): Promise<any> => {
        return Put(`/api/TbShop/PutPadShopLabelTemplateType`, body);
    };
    /**获取是否开通网店 */
    export var GetOnlineIsOpen = (): Promise<any> => {
        return Get(`/api/TbShop/GetOnlineIsOpen`, {});
    };
    /**开关备用金 */
    export var OpenImprest = (body): Promise<any> => {
        return Put(`/api/TbShop/OpenImprest`, body);
    };
    /**开关线上原路退款 */
    export var OpenOnlineRefund = (body): Promise<any> => {
        return Put(`/api/TbShop/OpenOnlineRefund`, body);
    };
}



// WEBPACK FOOTER //
// ./src/http/api_TbShop.ts